module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("正式老师(菲)")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "类型"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.category),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "category", _vm._n($$v))
      },
      expression: "queryParam.category"
    }
  }, _vm._l((_vm.teacherCategoryList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分配外教运营"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isStudyAdviser),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isStudyAdviser", _vm._n($$v))
      },
      expression: "queryParam.isStudyAdviser"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已分配")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分配")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "口音："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "accent", _vm._n($$v))
      },
      expression: "queryParam.accent"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("英音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("美音")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "性别："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "sex", _vm._n($$v))
      },
      expression: "queryParam.sex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID",
      "prop": "id"
    }
  }, [_c('Input', {
    attrs: {
      "name": "id"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师昵称"
    }
  }, [_c('Input', {
    attrs: {
      "name": "name",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.name),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "name", $$v)
      },
      expression: "queryParam.name"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "邀请人"
    }
  }, [_c('Input', {
    attrs: {
      "name": "inviteTchName",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.inviteTchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteTchName", $$v)
      },
      expression: "queryParam.inviteTchName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师账号"
    }
  }, [_c('Input', {
    attrs: {
      "name": "account",
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.account),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "account", $$v)
      },
      expression: "queryParam.account"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "授课类型",
      "prop": "tchType"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "data-value": "-1"
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.tchType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchType", _vm._n($$v))
      },
      expression: "queryParam.tchType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分配")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("外教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("中教")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("陪练")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 3
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否允许绑定："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.isCanBound),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "isCanBound", _vm._n($$v))
      },
      expression: "queryParam.isCanBound"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索\n      ")]), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.downloadLeaveTemplate
    }
  }, [_vm._v("下载请假模板")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadLeaveTemplate
    }
  }, [_vm._v("上传请假文件")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.allTeachersLeave
    }
  }, [_vm._v("全体老师请假")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onAssignAdviser
    }
  }, [_vm._v("分配外教运营")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addTch
    }
  }, [_vm._v("添加老师")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    staticClass: "pay-list",
    attrs: {
      "tableColumns": _vm.visibleColumns,
      "reload": _vm.reload,
      "reloadWithPage": _vm.reloadWithPage,
      "listUrl": "/tch/formal/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('TchCancelOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchCancelOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchCancelOpenedTimeModal = $$v
      },
      expression: "showTchCancelOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddOpenedTimeModal = $$v
      },
      expression: "showTchAddOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchEditOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchEditOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchEditOpenedTimeModal = $$v
      },
      expression: "showTchEditOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchCancelRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showCancelRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showCancelRandomOpenedTimeModal = $$v
      },
      expression: "showCancelRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchAddRandomOpenedTimeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchAddRandomOpenedTimeModal),
      callback: function($$v) {
        _vm.showTchAddRandomOpenedTimeModal = $$v
      },
      expression: "showTchAddRandomOpenedTimeModal"
    }
  }), _vm._v(" "), _c('TchLeaveModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveModal),
      callback: function($$v) {
        _vm.showTchLeaveModal = $$v
      },
      expression: "showTchLeaveModal"
    }
  }), _vm._v(" "), _c('TchLeaveOfficeModal', {
    attrs: {
      "tchId": _vm.tchId,
      "substituteList": _vm.substituteList
    },
    on: {
      "getProxyClassData": _vm.showProxyClass,
      "getCancelProxyClassData": _vm.cancelProxyClassData
    },
    model: {
      value: (_vm.showTchLeaveOfficeModal),
      callback: function($$v) {
        _vm.showTchLeaveOfficeModal = $$v
      },
      expression: "showTchLeaveOfficeModal"
    }
  }), _vm._v(" "), _c('ExportLeaveModal', {
    model: {
      value: (_vm.showExportLeaveModal),
      callback: function($$v) {
        _vm.showExportLeaveModal = $$v
      },
      expression: "showExportLeaveModal"
    }
  }), _vm._v(" "), _c('AssignTchStudyAdviserModal', {
    attrs: {
      "successCallback": _vm.searchWithPage,
      "tchList": _vm.selectionTch
    },
    model: {
      value: (_vm.showAssignTchStudyAdviserModal),
      callback: function($$v) {
        _vm.showAssignTchStudyAdviserModal = $$v
      },
      expression: "showAssignTchStudyAdviserModal"
    }
  }), _vm._v(" "), _c('TchInsertModal', {
    attrs: {
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.tchInsertModal),
      callback: function($$v) {
        _vm.tchInsertModal = $$v
      },
      expression: "tchInsertModal"
    }
  }), _vm._v(" "), _c('AllTeachersLeaveModal', {
    model: {
      value: (_vm.showAllTeacherLeaveModel),
      callback: function($$v) {
        _vm.showAllTeacherLeaveModel = $$v
      },
      expression: "showAllTeacherLeaveModel"
    }
  }), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  }), _vm._v(" "), _c('EditDingDingModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showEditDingModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeEditDingModal
    }
  }), _vm._v(" "), _c('TeachersDingTalkModal', {
    attrs: {
      "tchId": _vm.tchId,
      "value": _vm.showTeacherDingTalkModal,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeTeacherDingTalkModal
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "选择代课老师"
    },
    model: {
      value: (_vm.showSelectTch),
      callback: function($$v) {
        _vm.showSelectTch = $$v
      },
      expression: "showSelectTch"
    }
  }, [_c('Form', [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课节时间：" + _vm._s(_vm.lsnBeginTime) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学生姓名：" + _vm._s(_vm.selectTchParam.uid + '-' + _vm.selectTchParam.userNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          学习导师：" + _vm._s(_vm.selectTchParam.studyAdviserNickname) + "\n        ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n          课程顾问：" + _vm._s(_vm.selectTchParam.adviserNickname) + "\n        ")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "代课老师：",
      "label-width": 80
    }
  }, [_c('substitute-tch-select', {
    attrs: {
      "dataL": _vm.activityList,
      "openedId": _vm.selectTchParam.openedId
    },
    model: {
      value: (_vm.substituteTchId),
      callback: function($$v) {
        _vm.substituteTchId = $$v
      },
      expression: "substituteTchId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showSelectTch = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.updateTch
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "subject-type": "TEACHER",
      "snapshot-id": _vm.aiSnapshotId,
      "page-route": "/tch/filipino/tchFormalList",
      "default-task-type": "TCH_RISK_EXPLAIN"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.onAiExecuted,
      "on-close": _vm.onAiClose
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "800",
      "title": "操作记录"
    },
    model: {
      value: (_vm.showTchChangeModal),
      callback: function($$v) {
        _vm.showTchChangeModal = $$v
      },
      expression: "showTchChangeModal"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.tchChangeStatusColumn,
      "data": _vm.tchChangeStatusList
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17ed5da0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchFilipinoFormalList.vue
// module id = 1669
// module chunks = 8